export const animations = () => {
  //add animation classes
  const animatedEls = document.querySelectorAll('.animate');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        //if in view
        if (entry.intersectionRatio > 0) {
          entry.target.classList.add('animate-in');
          //console.log('in the view');
        } else {
          //entry.target.classList.remove("animate-in");
          //console.log('out of view');
        }
      });
    },
    {
      threshold: 0.5,
    },
  );

  animatedEls.forEach((animatedEl) => {
    observer.observe(animatedEl);
  });
};
